// extracted by mini-css-extract-plugin
module.exports = {"radioButtonBoxGroup":"components-base-RadioButtonBoxGroup-RadioButtonBoxGroup__radioButtonBoxGroup--3Gqhg"};